import { NgModule } from '@angular/core';
import { CdkAccordionModule } from "@angular/cdk/accordion";
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { RouterModule } from '@angular/router';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AreYouSureComponent } from "./are-you-sure/are-you-sure.component";
import { AreYouSure2Component } from './are-you-sure2/are-you-sure2.component';
import { BannerAlertComponent } from "./banner-alert/banner-alert.component";
import { BannerErrorComponent } from "./banner-error/banner-error.component";
import { BannerNotifyComponent } from "./banner-notify/banner-notify.component";
import { ChevronToggleComponent } from "./chevron-toggle/chevron-toggle.component";
import { CompletionIndicatorComponent } from "./completion-indicator/completion-indicator.component";
import { DialogHandlerComponent } from './dialog-handler/dialog-handler.component';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';
import { FleetOrderComponent } from './fleet-order/fleet-order.component';
import { GrayLabelWrapperComponent } from './gray-label-wrapper/gray-label-wrapper.component';
import { IsmMarqueeComponent } from "./ism-marquee/ism-marquee.component";
import { IsmSvgComponent } from "./ism-svg/ism-svg.component";
import { MenuItemsCenterComponent } from "./navbar-top/menu-items-center/menu-items-center.component";
import { MenuItemsRightComponent } from "./navbar-top/menu-items-right/menu-items-right.component";
import { MenuItemsTestingComponent } from "./navbar-top/menu-items-testing/menu-items-testing.component";
import { NavbarTopComponent } from "./navbar-top/navbar-top.component";
import { RevealPasswordComponent } from "./reveal-password/reveal-password.component";
import { SimpleListComponent } from './simple-list/simple-list.component';
import { StarfireImageComponent } from "./starfire-image/starfire-image.component";
import { StarSystemDisplayComponent } from "./star-system-display/star-system-display.component";
import { StarSystemDisplayAdminComponent } from "./star-system-display-admin/star-system-display-admin.component";
import { TestingIsmComponent } from "./testing-ism/testing-ism.component";
import { TurnSelectorComponent } from './turn-selector/turn-selector.component';
import { WhirlySpinnerComponent } from './whirly-spinner/whirly-spinner.component';

import { OpenLinkDirective } from './open-link.directive';
import { ScrollToTopDirective } from './scroll-to-top.directive';

import { FilterKeyValuePipe } from './filter-key-value.pipe';
import { FleetFilterPipe } from './fleet-filter';
import { KeyObjectPipe } from './key-object.pipe';
import { OrderByPipe } from './order-by.pipe';
import { OutfitKeyValuePipe } from './outfit-key-value.pipe';
import { TechLevelComponent } from './tech-level/tech-level.component';

@NgModule({
  declarations: [
    AreYouSureComponent,
    AreYouSure2Component,
    BannerAlertComponent,
    BannerErrorComponent,
    BannerNotifyComponent,
    ChevronToggleComponent,
    CompletionIndicatorComponent,
    DialogHandlerComponent,
    EditDialogComponent,
    FilterKeyValuePipe,
    FleetFilterPipe,
    FleetOrderComponent,
    GrayLabelWrapperComponent,
    IsmMarqueeComponent,
    IsmSvgComponent,
    KeyObjectPipe,
    MenuItemsCenterComponent,
    MenuItemsRightComponent,
    MenuItemsTestingComponent,
    NavbarTopComponent,
    OpenLinkDirective,
    OrderByPipe,
    OutfitKeyValuePipe,
    RevealPasswordComponent,
    ScrollToTopDirective,
    SimpleListComponent,
    StarSystemDisplayComponent,
    StarSystemDisplayAdminComponent,
    StarfireImageComponent,
    TestingIsmComponent,
    TurnSelectorComponent,
    WhirlySpinnerComponent,
    TechLevelComponent,
  ],
  exports: [
    AreYouSureComponent,
    AreYouSure2Component,
    BannerAlertComponent,
    BannerErrorComponent,
    BannerNotifyComponent,
    ChevronToggleComponent,
    CompletionIndicatorComponent,
    EditDialogComponent,
    FilterKeyValuePipe,
    FleetFilterPipe,
    FleetOrderComponent,
    GrayLabelWrapperComponent,
    IsmMarqueeComponent,
    IsmSvgComponent,
    KeyObjectPipe,
    MenuItemsCenterComponent,
    MenuItemsRightComponent,
    MenuItemsTestingComponent,
    NavbarTopComponent,
    OpenLinkDirective,
    OrderByPipe,
    OutfitKeyValuePipe,
    RevealPasswordComponent,
    ScrollToTopDirective,
    StarSystemDisplayComponent,
    StarSystemDisplayAdminComponent,
    StarfireImageComponent,
    TechLevelComponent,
    TestingIsmComponent,
    TurnSelectorComponent,
    WhirlySpinnerComponent,
  ],
  imports: [
    CdkAccordionModule,
    CommonModule,
    FormsModule,
    RouterModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class SharedModule { }
